/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const UserStatus = createEnum('USER_STATUS', {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Transferred: 'TRANSFERRED',
  Deleted: 'DELETED',
  In_Deletion: 'IN_DELETION'
});

export type UserStatus = EnumSet<typeof UserStatus>;
